<template>
  <div class="right-box">
    <div class="right-box-view-panel">
      <div class="row" v-if="computedTitle">
        <span class="right-box-title">{{ computedTitle }}</span>
      </div>

      <div
        v-for="(item, index) in items"
        :key="index"
        class="row"
      >
        <div class="col-md-6">
          <div class="right-box-label-content">
            <span>{{ getLabel(item) }}</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="right-box-value-content">
            <span :style="getValueStyle(item)">
              {{ getDisplayValue(item) }}
            </span>
          </div>
        </div>
      </div>

      <div class="right-box-extra">
        <slot />
      </div>

      <div class="right-box-save-button">
        <SmagriaButton
          :label="$t('common.save')"
          :disabled="saving"
          :action="emitSave"
          :customClass="'primary'"
        />
      </div>
      <div v-if="showSaveAndNew" class="right-box-save-button">
        <SmagriaButton
          :label="$t('common.save_and_new')"
          :disabled="saving"
          :action="emitSaveAndNew"
          :customClass="'primary border'"
        />
      </div>
      <div class="right-box-save-button">
        <SmagriaButton
          :label="$t('common.back_to_list')"
          :disabled="saving"
          :action="emitBackToList"
          :customClass="'reset border'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SmagriaButton from "@/components/Common/SmagriaButton.vue";
export default {
  name: "RightInfoPanelGeneric",
  props: {
    // Object that holds all values to display
    value: {
      type: Object,
      required: true,
    },
    // Panel title: either i18n key or plain string
    titleKey: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    // Items config: [{ labelKey?, label?, path, required?, formatter? }]
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    saving: {
      type: Boolean,
      default: false,
    },
    showSaveAndNew: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SmagriaButton,
  },
  computed: {
    computedTitle() {
      if (this.titleKey) {
        return this.$t(this.titleKey);
      }
      return this.title;
    },
  },
  methods: {
    getLabel(item) {
      if (item.labelKey) {
        return this.$t(item.labelKey);
      }
      return item.label || "";
    },
    getRawValue(item) {
      if (!item || !item.path) {
        return null;
      }
      const segments = item.path.split(".");
      let current = this.value || {};
      for (let i = 0; i < segments.length; i++) {
        if (current == null) {
          return null;
        }
        current = current[segments[i]];
      }
      return current;
    },
    getDisplayValue(item) {
      let raw = this.getRawValue(item);

      if (typeof item.formatter === "function") {
        return item.formatter(raw, this.value);
      }

      if (raw === null || raw === undefined || raw === "") {
        if (item.required) {
          return "*";
        }
        return "-";
      }

      return raw;
    },
    getValueStyle(item) {
      const raw = this.getRawValue(item);
      if (item.required && (raw === null || raw === undefined || raw === "")) {
        return { color: "red" };
      }
      return { color: "inherit" };
    },
    emitSave() {
      this.$emit("save");
    },
    emitSaveAndNew() {
      this.$emit("saveAndNew");
    },
    emitBackToList() {
      this.$emit("back");
    },
  },
};
</script>

<style scoped>
.right-box {
  width: 300px;
  min-width: 300px;
  flex: 0 0 300px;
  border-left: 1px solid #ddd;
  padding: 0px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  align-self: stretch;
}

.right-box-view-panel {
  width: 100%;
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 5px;
  padding-bottom: 15px;
  background-color: #f0f0f0;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  justify-content: center;
}

.right-box-title {
  font-size: 20px;
  font-weight: 700;
  color: #323232;
  margin-bottom: 15px;
  text-align: left;
}

.right-box-label-content {
  font-size: 13px;
  padding-bottom: 5px;
}

.right-box-value-content {
  font-size: 13px;
  font-weight: bold;
  padding-bottom: 5px;
}

.right-box-extra {
  margin-top: 20px;
}

.right-box-save-button {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
</style>
